export const CLEAR_INFO = 'CLEAR_INFO';
export const SET_INFO = 'SET_INFO';
